const SPIN_TEST_ID = "ui-library-spin";

export { SPIN_TEST_ID };
